<template>
    <ubi-page-container>
        <template v-slot:page-actions v-if="post">
            <el-button
                    :to="{ name: 'post-edit', params: { id: post.id }, query: { saisie: post.sourceCode } }"
                    type="primary"
                    :disabled="!post"
                    class="inline"
                    v-if="saisit_en_ligne && post.etat != 'V' && post.etat != 'S'"
            >
                <span @click="eventAnalytics('edit_fiche')">{{ $t("posts.view.edit") }}</span>
            </el-button>
            <el-button
                    :to="{ name: 'private-note', params: { id: post.id }, query: { saisie: post.sourceCode  } }"
                    :disabled="!post"
                    class="inline"
                    v-loading="loadingButton"
                    v-if="post.etat != 'V' && post.etat != 'S' && post.etat != 'M'"
            >
                <span @click="eventAnalytics('acces_note_privee')">{{ $t("posts.card.privateNote") }}</span>
            </el-button>

            <el-button
                    id="show-modal"
                    @click="showModal = true"
                    :disabled="!post"
                    class="inline"
                    v-loading="loadingButton"
            >{{ $t("posts.view.sendByEmail") }}
            </el-button>

          <el-dropdown @command="handleCommandPrint" v-if="universe === 'IMMO' && ((post.typeObjet >= 1000 && post.typeObjet < 4000) || (post.typeObjet === 5200))">
            <el-button type="primary" style="margin-left: 12px;">{{ $t("posts.view.print") }}</el-button>
            <el-dropdown-menu>
              <el-dropdown-item command="ficheInformative">{{ $t("posts.view.printInfo") }}</el-dropdown-item>
              <el-dropdown-item command="vitrine">{{ $t("posts.view.printVitrine") }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
            <el-button
                    @click="enregistrerPDF"
                    type="primary"
                    :disabled="!post"
                    class="inline"
                    v-loading="loadingButton"
                    v-else
            >{{ $t("posts.view.print") }}
            </el-button>
        </template>

        <router-link :to="{ name: 'posts' }">
            <el-link class="mb-3">{{ $t(goBackTitle) }}</el-link>
        </router-link>

        <!-- DEBUT MODAL-->
        <transition name="modal" v-if="showModal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <h2 class="modal-header">
                            <slot name="header">
                                {{ $t("posts.view.sendByEmailTitle") }}
                            </slot>
                        </h2>

                        <div class="modal-body">
                            <slot name="body">
                                {{ $t("posts.view.sendByEmailRecipient") }}
                                <el-input v-model="emailDestinataire"></el-input>
                                <span v-if="invalidEmail" style="color: red">{{ $t("validator.validEmail") }}</span>
                                <br>
                                <br>
                                {{ $t("posts.view.sendByEmailMessage") }}
                                <el-input
                                        type="textarea"
                                        :rows="10"
                                        v-model="commentaireEmail">
                                </el-input>
                            </slot>
                        </div>

                        <div class="modal-footer">
                            <slot name="footer">
                                <el-button
                                        @click="showModal = false"
                                        class="inline"
                                >{{ $t("posts.view.cancel") }}
                                </el-button>
                              <el-button type="primary" style="margin-left: 12px;" v-if="universe === 'IMMO' && post.typeObjet >= 1000 && post.typeObjet < 3000" @click="sendByEmail('vitrine')">{{ $t("posts.view.sendVitrine") }}</el-button>
                              <el-button type="primary" style="margin-left: 12px;" v-if="universe === 'IMMO' && post.typeObjet >= 1000 && post.typeObjet < 3000" @click="sendByEmail">{{ $t("posts.view.sendInfo") }}</el-button>
                                <el-button
                                        type="primary"
                                        :disabled="!emailDestinataire"
                                        class="inline"
                                        @click="sendByEmail"
                                        v-loading="loading"
                                        v-else
                                >{{ $t("posts.view.send") }}
                                </el-button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <!--FIN MODAL-->

        <div id="printDiv" class="divPanel" v-if="post" onload="pageChargee()">
            <!--DEBUT Photo-->
            <div>
                <div v-if="universe == 'VO'">
                    <el-row>
                        <el-col :lg="14">
                            <h1>{{post.titre}}</h1>
                        </el-col>
                        <el-col :lg="10" style="text-align: right">
                            <h1>{{post.reference}}</h1>
                        </el-col>
                    </el-row>
                </div>
                <div v-else>
                    <h1>{{post.titre}}</h1>
                </div>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
                        <div>
                            <div id="blockPrincipal" class="text-center">
                                <el-image id="imageAgrandit" v-if="post.photoPrincipale != null"
                                          :src="post.photoPrincipale.url" fit="contain"></el-image>
                                <div class="text-center" v-else>
                                    <ubi-icon class="no-photo" name="camera" size='250'/>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                        <div><el-image v-if="sitimmoUser.logoUrl != null"
                                       :src="sitimmoUser.logoUrl" :srcset="'data:image/png;base64,' + sitimmoUser.logo" fit="contain"
                                       id="postViewLogoAgence"/></div>
                        <br/>
                        <div class="text-left" style="margin-top: 1%">
                            <div v-if="universe === 'VO'"></div>
                            <div v-else>
                                <div>Réf : {{post.reference}}</div>
                                <div v-if="isPromoteur && !filter.annonceParente" class="text-left">
                                    <div v-if="post.programme_neuf_nom">
                                        {{ $t("posts.view.name", { name: post.programme_neuf_nom}) }}
                                    </div>
                                    <div v-if="post.ville">
                                        {{ $t("posts.view.cityPromoteur") }} {{ post.code_postal}} {{ post.ville}}
                                    </div>
                                    <div v-if="post.prix_min">
                                        {{ $t("posts.view.priceMin", { price: post.prix_min}) }} {{ post.devise_iso_4217 }}
                                    </div>
                                    <div v-if="post.surface_max">
                                        {{ $t("posts.view.surfaceMinMax", { min: post.surface_min, max:
                                        post.surface_max}) }}
                                    </div>
                                </div>
                                <div v-else class="text-left">
                                    <div v-if="post.ville && universe === 'IMMO'">
                                        {{ $t("posts.view.city") }} {{ post.ville}}
                                    </div>
                                    <div v-if="post.prix && universe === 'IMMO'">
                                        {{ $t("posts.view.price", { price: post.prix}) }} {{ post.devise_iso_4217 }}
                                    </div>
                                    <div v-if="post.depot_garantie && universe === 'IMMO'">
                                        {{ $t("posts.view.depotGarantie") }} : {{ post.depot_garantie }} {{ post.devise_iso_4217 }}
                                    </div>
                                    <div v-if="post.honoraires_location && universe === 'IMMO'">
                                        {{ $t("posts.view.honorairesLocation") }} : {{ post.honoraires_location }} {{ post.devise_iso_4217 }}
                                    </div>
                                    <div v-if="post.tarif_hebdo_basse_saison">
                                        {{ $t("posts.view.priceLowSeason", { price:
                                        post.tarif_hebdo_basse_saison}) }} {{ post.devise_iso_4217 }}
                                    </div>
                                    <div v-if="post.tarif_hebdo_moyenne_saison">
                                        {{ $t("posts.view.priceMiddleSeason", { price:
                                        post.tarif_hebdo_moyenne_saison}) }} {{ post.devise_iso_4217 }}
                                    </div>
                                    <div v-if="post.tarif_hebdo_haute_saison">
                                        {{ $t("posts.view.priceHighSeason", { price:
                                        post.tarif_hebdo_haute_saison}) }} {{ post.devise_iso_4217 }}
                                    </div>
                                    <div v-if="post.afficher_prix=='non'">
                                        {{ $t("posts.view.priceContactUs") }}
                                    </div>
                                    <div v-if="post.surface_habitable">
                                        {{ $t("posts.view.surface", { surface: post.surface_habitable }) }}
                                    </div>
                                    <div v-if="post.nb_pieces_logement">
                                        {{ $t("posts.view.roomsNumber", { number: post.nb_pieces_logement }) }}
                                    </div>
                                    <div v-if="post.typeOffre == 'V'">{{ $t("posts.view.offerTypeV") }}</div>
                                </div>
                            </div>
                            <br />
                            <h4 v-if="universe !=='VO'"><strong>{{ $t("posts.view.contactTitle") }}</strong></h4>
                            <h4 v-else><strong>{{$t('users.contact')}}</strong></h4>
                            <div v-if="post.contact_a_afficher">{{ post.contact_a_afficher }}</div>
                            <div v-if="post.telephone_a_afficher || post.telephone_mobile_a_afficher">
                                <div v-if="post.telephone_a_afficher">{{ $t("users.phone") }} : {{ post.telephone_a_afficher }}</div>
                                <div v-if="post.telephone_mobile_a_afficher">{{ $t("users.mobile") }} : {{ post.telephone_mobile_a_afficher }}</div>
                            </div>
                            <div v-else>{{ $t("users.phone") }} : {{ user.phone }}</div>
                            <div v-if="post.email_a_afficher">{{ $t("users.email") }} : {{ post.email_a_afficher }}</div>
                            <div v-else>{{ $t("users.email") }} : {{ user.email }}</div>
                            <div v-if="sitimmoUser.siteWeb">{{ $t("website.title") }} : {{ sitimmoUser.siteWeb }}</div>
                            <div>{{ $t("users.address") }} : {{ sitimmoUser.adresse }}</div>
                            <div>{{ $t("users.city") }} : {{ sitimmoUser.ville }}</div>
                            <div>{{ $t("users.postalCode") }} : {{ sitimmoUser.codePostal }}</div>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="universe === 'IMMO'">
                    <!--DEBUT - MINATURE DE TOUTES LES PHOTO -->
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" id="blockPhotosImmoVo">
                        <div class="demo-image__placeholder" >
                            <!--ICI ON PARCOURS TOUTES LES PHOTOS POUR LES AFFICHER EN MINATURE SOUS LA PHOTO PRINCIPALE.-->
                            <a v-for="photo in post.photos" @click="agrandirPhoto(photo.url)">
                                <el-image :src='photo.url' class="photosAffichette"></el-image>
                            </a>
                            <!--(LA PHOTO PRINCIPALE EST LA PREMIERE MINATURE-->
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                        <EtiquetteDPEGES :post="post"></EtiquetteDPEGES>
                        <br>
                        <br>
                    </el-col>
                </el-row>
            </div>
            <PostViewImmo v-if="universe === 'IMMO' && labelsLoaded" :post="post"></PostViewImmo>
            <PostViewVo v-else-if="universe === 'VO' && labelsLoaded" :post="post"></PostViewVo>
        </div>
      <div id="printHidden" style="display: none">
        <div id="printDivVo" class="divPanel" v-if="post && universe === 'VO'" onload="pageChargee()">
          <post-pdf-vo :post="post" :sitimmo-user="sitimmoUser" :universe="universe"></post-pdf-vo>
        </div>
        <div id="printDivImmoAncien" class="divPanel" v-if="post && post.typeObjet >= 1000 && post.typeObjet < 3000 && !isPromoteur" onload="pageChargee()">
          <post-pdf-immo-ancien :post="post" :sitimmo-user="sitimmoUser" :universe="universe"></post-pdf-immo-ancien>
        </div>
        <div id="printDivPromoteur" class="divPanel" v-if="isPromoteur" onload="pageChargee()">
          <post-pdf-immo-promoteur :post="post" :sitimmo-user="sitimmoUser" :universe="universe"></post-pdf-immo-promoteur>
        </div>
        <div id="printDivCmiste" class="divPanel" v-if="isCmiste" onload="pageChargee()">
          <post-pdf-immo-c-m-i :post="post" :sitimmo-user="sitimmoUser" :universe="universe"></post-pdf-immo-c-m-i>
        </div>
      </div>

    </ubi-page-container>
</template>

<script>
import { PostMixin } from '../posts'
import UbiPanel from '../../../components/Panel'
import ElButton from '../../../components/Button'
import { sendEmail } from '../../../services/email'
import html2pdf from 'html2pdf.js'
import { gestionPDF } from '../../../services/pdf'
import PostViewImmo from './PostViewImmo'
import PostViewVo from './PostViewVo'
import { mapState } from 'vuex'
import EtiquetteDPEGES from '../forms/Block/EtiquetteDPEGES'
import PostPdfVo from '@/pages/posts/View/PostPdfVo'
import PostPdfImmoAncien from '@/pages/posts/View/PostPdfImmoAncien'
import PostPdfImmoPromoteur from '@/pages/posts/View/PostPdfImmoPromoteur'
import PostPdfImmoCMI from '@/pages/posts/View/PostPdfImmoCMI.vue'

export default {
  name: 'PostView',
  components: { ElButton, UbiPanel, PostViewImmo, PostViewVo, EtiquetteDPEGES, PostPdfVo, PostPdfImmoAncien, PostPdfImmoPromoteur, PostPdfImmoCMI },
  inject: ['browserContext'],
  mixins: [PostMixin],
  data () {
    return {
      loading: false,
      loadingButton: true,
      photoAgrandit: null,
      photoPrincipale: null,
      showModal: false,
      emailDestinataire: null,
      invalidEmail: false,
      commentaireEmail: this.$t('posts.view.sendByEmailComment'),
      post: null,
      labelsLoaded: false,
      nouvelleFiche: false
    }
  },
  computed: {
    ...mapState('posts', ['filter', 'results']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    saisit_en_ligne () {
      return this.sitimmoUser.saisit_annonces_en_ligne === true
    },
    universe () {
      return this.sitimmoUser.univers
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    goBackTitle () {
      if (this.isPromoteur) {
        if (this.filter.annonceParente) {
          return this.$t('posts.view.goBackTitleLots')
        } else {
          return this.$t('posts.view.goBackTitlePrograms')
        }
      }
      return this.$t('posts.view.goBackTitleAds')
    },
    pageTitle () {
      if (this.isPromoteur) {
        if (this.filter.annonceParente) {
          return this.$t('posts.view.pageTitleLot')
        } else {
          return this.$t('posts.view.pageTitleProgram')
        }
      }
      return this.$t('posts.view.pageTitleAd')
    }
  },
  beforeMount () {
    this.$route.meta.title = this.pageTitle
  },
  mounted () {
    this.pageChargee()
  },
  created () {
    // si on fait un changement de langue, les labels peuvent ne pas avoir le temps de
    // se charger. Le code suivant attend un peu avant d'afficher les components si besoin.
    if (this.$labels === undefined) {
      setTimeout(() => {
        this.labelsLoaded = true
      }, 4000)
    } else {
      this.labelsLoaded = true
    }
  },
  methods: {
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.sitimmoUser.id)
    },
    pageChargee () {
      setTimeout(this.loadingButton = false, 60000)
    },
    replaceApostrophes (text) {
      return text.replace('\'', ' ')
    },
    async enregistrerPDF (type) {
      window.scrollTo(0, 0)
      this.eventAnalytics('print_fiche')
      const opt = {
        filename: this.$t('posts.view.printFilename'),
        margin: 1,
        html2canvas: { scale: 2, scrollX: 0, scrollY: 0, useCORS: true, allowTaint: true },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'], before: '#sautDeLigneAffiche' },
        jsPDF: {
          precision: 1,
          unite: 'in',
          orientation: 'portrait',
          format: 'a4',
          compress: true
        }
      }
      if (this.sitimmoUser.univers === 'IMMO') {
        opt.margin = [10, 4, 15, 4]
      } else {
        opt.margin = [0, 0, 0, 0]
      }
      if (this.post.typeObjet >= 1000 && this.post.typeObjet < 3000 && type === 'vitrine') {
        opt.margin = [0, 0, 0, 0]
        this.nouvelleFiche = true
      }
      if (this.isPromoteur && type === 'vitrine') {
        opt.margin = [0, 0, 0, 0]
        this.nouvelleFiche = true
      }
      if (this.isCmiste && type === 'vitrine') {
        opt.margin = [0, 0, 0, 0]
        this.nouvelleFiche = true
      }
      let divId = 'printDiv'
      if (this.universe === 'VO') {
        divId = 'printDivVo'
      }
      if (this.post.typeObjet >= 1000 && this.post.typeObjet < 3000 && type === 'vitrine') {
        divId = 'printDivImmoAncien'
      }
      if (this.isPromoteur && type === 'vitrine') {
        divId = 'printDivPromoteur'
      }
      if (this.isCmiste && type === 'vitrine') {
        divId = 'printDivCmiste'
      }
      const element = document.getElementById(divId)
      let elementClone = element.cloneNode(true)
      // element = await gestionPDF(element, this.sitimmoUser.univers, this.sitimmoUser.metier);
      elementClone = await gestionPDF(elementClone, this.sitimmoUser.univers, this.sitimmoUser.metier, this.post.annonceParente, this.nouvelleFiche)
      await html2pdf().set(opt).from(elementClone).save()
    },

    agrandirPhoto (picture) {
      document.getElementById('imageAgrandit').src = picture
      window.scrollTo(0, 0)
    },
    displayBoolean (value) {
      if (value === true) {
        return this.$t('general.yes')
      }
      if (value === false) {
        return this.$t('general.no')
      }
      return null
    },
    handleCommandPrint (command) {
      switch (command) {
        case 'vitrine':
          this.enregistrerPDF('vitrine')
          break
        default:
          this.enregistrerPDF()
          break
      }
    },
    async sendByEmail (type) {
      // check email
      this.invalidEmail = false
      if (!this.isValidEmail(this.emailDestinataire)) {
        this.invalidEmail = true
        return
      }

      window.scrollTo(0, 0)
      this.eventAnalytics('export_fiche')
      this.loading = true
      const opt = {
        filename: this.$t('posts.view.printFilename'),
        margin: 1,
        html2canvas: { scale: 2, scrollX: 0, scrollY: 0, useCORS: true, allowTaint: true },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'], before: '#sautDeLigneAffiche' },
        jsPDF: {
          precision: 1,
          unite: 'in',
          orientation: 'portrait',
          format: 'a4',
          compress: true
        }
      }
      if (this.sitimmoUser.univers === 'IMMO') {
        opt.margin = [10, 4, 15, 4]
      } else {
        opt.margin = [0, 0, 0, 0]
      }
      if (this.post.typeObjet >= 1000 && this.post.typeObjet < 3000 && type === 'vitrine') {
        opt.margin = [0, 0, 0, 0]
        this.nouvelleFiche = true
      }
      if (this.isPromoteur && type === 'vitrine') {
        opt.margin = [0, 0, 0, 0]
        this.nouvelleFiche = true
      }
      if (this.isCmiste && type === 'vitrine') {
        opt.margin = [0, 0, 0, 0]
        this.nouvelleFiche = true
      }
      let divId = 'printDiv'
      // if (this.universe === 'VO') {
      //   divId = 'printDivVo'
      // }
      if (this.post.typeObjet >= 1000 && this.post.typeObjet < 3000 && type === 'vitrine') {
        divId = 'printDivImmoAncien'
      }
      if (this.isPromoteur && type === 'vitrine') {
        divId = 'printDivPromoteur'
      }
      if (this.isCmiste && type === 'vitrine') {
        divId = 'printDivCmiste'
      }

      const element = document.getElementById(divId)
      let elementClone = element.cloneNode(true)
      // element = await gestionPDF(element, this.sitimmoUser.univers, this.sitimmoUser.metier);
      elementClone = await gestionPDF(elementClone, this.sitimmoUser.univers, this.sitimmoUser.metier, this.post.annonceParente, this.nouvelleFiche)
      html2pdf().set(opt).from(elementClone).outputPdf('blob').then(async (pdf) => {
        // handle your result here...
        const self = this
        // TODO : Les constantes ne sont pas utilisées, ça ne marchera pas
        // const logo = processEnvConfig.VUE_APP_IMAGE_FILIGRANE_MAIL
        // const content = '<div style="width: 700px; margin: auto;"> <div style="background-color: #255662; height: 140px; width: 700px; margin-bottom: 50px"> <img style="width: 350px; margin-top: 6%; margin-left: 29%" src="' + logo + '"> </div><p style="font-family: Dosis, Arial, Helvetica, sans-serif; font-size: large;text-align: center;">' + self.commentaireEmail + '</p></div>'
        // content.outerHTML
        const reader = new FileReader()
        reader.readAsDataURL(pdf)
        reader.onload = async function () {
          const base64data = reader.result.replace(/^data:.+;base64,/, '')
          const mailData = {
            to: self.emailDestinataire,
            subject: self.$t('posts.view.sendByEmailSubject', { postTitle: self.post.titre }),
            content: self.commentaireEmail,
            attachments: [{
              name: self.$t('posts.view.sendByEmailAttachment', { reference: self.post.reference }),
              content: base64data,
              type: 'application/pdf'
            }]
          }
          const response = await sendEmail(mailData)
          if (response.type === 'error') {
            this.$message({ message: this.$t('error.found'), type: 'error' })
            this.loading = false
            return false
          }
          self.$message(response)
          self.loading = false
          self.showModal = false
          self.invalidEmail = false
        }
      })
    },
    isValidEmail (email) {
      return /\S+@\S+\.\S+/.test(email)
    }
  }
}
</script>

<style>
    .divPanel {
        padding: 3%;
        background-color: white;
    }

    #blockInformation {
        background-color: white;
    }

    #blockPhotosImmoVo {
        display: inline-block;
    }

    #blockPrincipal {
        width: 100%;
        height: auto;
    }

    #imageAgrandit {
        max-width: 90%;
    }

    .photosAffichette {
        max-height: 70px;
        margin-right: 3px;
        max-width: 140px;
        overflow: visible;
        width: auto;
    }

    .photosAffichette img {
        height: 70px;
        max-width: 140px;
        width: auto;
    }

    /*DEBUT POPUP ENVOYER ANNONCE*/
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 600px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /*FIN POPUP ENVOYER ANNONCE*/

    #postViewLogoAgence{
        width: 150px;
    }
</style>
